const metas = [
  { charset: 'utf-8' },
  {
    name: 'viewport',
    content: 'width=device-width, initial-scale=1, shrink-to-fit=no',
  },
  {
    'http-equiv': 'x-ua-compatible',
    content: 'ie:edge',
  },
  {
    'http-equiv': 'CONTENT-LANGUAGE',
    content: 'en-US',
  },
  {
    'http-equiv': 'x-dns-prefetch-control',
    content: 'on',
  },
  {
    name: 'msapplication-config',
    content: '/app/static/app/IEconfig.xml',
  },
  {
    name: 'robots',
    content: 'noindex',
  },
  {
    property: 'og:site_name',
    content: 'Angi Business Center',
  },
  {
    name: 'google',
    content: 'nositelinkssearchbox',
  },
  {
    property: 'og:phone_number',
    content: '18888192644',
  },
  {
    property: 'og:email',
    content: 'angi@angi.com',
  },
  {
    property: 'og:description',
    content: 'Find the Best Local Roofers - Plumbers - Remodelers - Handymen - Doctors - Dentists - More! Deals - Local Ratings - Reviews',
  },
  {
    property: 'og:url',
    content: 'https://office.angi.com/',
  },
  {
    name: 'description',
    content: 'Angi offers Fair Price and Service Quality Guarantees to over 5 million members. Join to read reviews on local service providers or shop offers for free!',
  },
];


const htmlAttributes = {
  xmlns: 'https://www.w3.org/1999/xhtml',
  lang: 'en',
  'xml:lang': 'en',
  version: 'XHTML+RDFa 1.0',
  dir: 'ltr',
  'xmlns:content': 'https://purl.org/rss/1.0/modules/content/',
  'xmlns:dc': 'https://purl.org/dc/terms/',
  'xmlns:foaf': 'https://xmlns.com/foaf/0.1/',
  'xmlns:og': 'https://ogp.me/ns#',
  'xmlns:rdfs': 'https://www.w3.org/2000/01/rdf-schema#',
  'xmlns:sioc': 'https://rdfs.org/sioc/ns#',
  'xmlns:sioct': 'https://rdfs.org/sioc/types#',
  'xmlns:skos': 'https://www.w3.org/2004/02/skos/core#',
  'xmlns:xsd:': 'https://www.w3.org/2001/XMLSchema#',
  'xmlns:schema': 'https://schema.org/',
  'xmlns:article': 'https://ogp.me/ns/article#',
  'xmlns:book': 'https://ogp.me/ns/book#',
  'xmlns:profile': 'https://ogp.me/ns/profile#',
  'xmlns:video': 'https://ogp.me/ns/video#',
};

const links = [
  {
    rel: 'dns-prefetch',
    href: '//img.alcdn.com',
  },
];

export { metas, links, htmlAttributes };



// WEBPACK FOOTER //
// ./src/app/browser/meta.js